<template>
  <div>
    <v-list>
      <ListItem
        :title="warehouse.name"
        :subtitle="$t('fields.name')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'WarehouseDetails',
    components: { ListItem },
    props: {
      warehouse: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
